import { _ as e } from "./index.es567.js";
var a = e,
    m = /^\s+/;

function d(r) {
  return r && r.slice(0, a(r) + 1).replace(m, "");
}

var t = d;
export { t as _ };